<template>
  <div class="time bounding-box">
    <h4>This will be the time caluclation page.</h4>
  </div>
</template>
<style lang="scss">
@import "../styles/variables";
</style>
